import i18n from "@/plugins/vue-i18n";

const Shipments = () => import("@/views/shipments/index");
const ShipmentsEdit = () => import("@/views/shipments/edit");
const ShipmentsAdd = () => import("@/views/shipments/add");

const shipments = [
  {
    path: "/shipments",
    name: "Shipments",
    component: Shipments,
    meta: {
      title: i18n.t("title.shipments._"),
    },
  },
  {
    path: "/shipments/add",
    name: "ShipmentsAdd",
    component: ShipmentsAdd,
    meta: {
      title: i18n.t("title.shipments._"),
    },
  },
  {
    path: "/shipments/:id",
    name: "ShipmentsEdit",
    component: ShipmentsEdit,
    meta: {
      title: i18n.t("title.shipments._"),
    },
  },
];

export default shipments;
